module.exports = __webpack_public_path__ + "img/share-2.eec595ec.svg";